import { Avatar, Badge, Theme, createStyles, makeStyles, withStyles } from "@material-ui/core";

import TwitterShare from '../../assets/images/twitter-share.png';

const SmallAvatar = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 22,
      height: 22,
      border: `2px solid ${theme.palette.background.paper}`,
    },
  }),
)(Avatar);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    badge: {
      marginRight: theme.spacing(2),
    }
  }),
);

export default function BadgeAvatars({ src }: any) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Badge
        overlap="circular"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        badgeContent={<SmallAvatar alt="Twitter" src={TwitterShare} />}
        className={classes.badge}
      >
        <Avatar alt="Project Link" src={src} />
      </Badge>
    </div>
  );
}